<template>
  <main class="not-found">
    <section class="card not-found-card">
      <svg class="not-found-art" viewBox="0 0 200 120" role="img" aria-label="Erro 404" xmlns="http://www.w3.org/2000/svg">
        <text x="100" y="82" text-anchor="middle" font-size="84" font-weight="800" fill="#3366cc" opacity="0.14" font-family="Avenir, Helvetica, Arial, sans-serif">404</text>
        <circle cx="88" cy="56" r="28" fill="#fff" stroke="#3366cc" stroke-width="6"/>
        <line x1="108" y1="76" x2="132" y2="100" stroke="#3366cc" stroke-width="8" stroke-linecap="round"/>
        <path d="M78 66c4-6 16-6 20 0" fill="none" stroke="#e74c3c" stroke-width="4" stroke-linecap="round"/>
        <circle cx="78" cy="48" r="3.5" fill="#2c3e50"/>
        <circle cx="98" cy="48" r="3.5" fill="#2c3e50"/>
      </svg>
      <h1 class="not-found-title">Página não encontrada</h1>
      <p class="not-found-text">O endereço que você tentou acessar não existe ou foi movido.</p>
      <router-link to="/" class="btn-primary">Voltar para o início</router-link>
    </section>
  </main>
</template>

<script>
export default { name: 'NotFoundPage' }
</script>

<style scoped>
.not-found {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-base);
}
.not-found-card {
  width: 100%;
  max-width: 440px;
  padding: var(--spacing-xl) var(--spacing-lg);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: var(--spacing-md);
}
.not-found-art { width: 200px; height: auto; margin-bottom: var(--spacing-md); }
.not-found-title { font-size: var(--text-xl); color: var(--color-text-primary); }
.not-found-text { font-size: var(--text-sm); color: var(--color-text-muted); margin-bottom: var(--spacing-md); }
</style>
